import { z } from 'zod';
import { apiGet, apiSend } from '@/lib/api';

const BrandingSchema = z.object({
  /** nazwa instancji albo nazwa produktu — NIGDY pusty napis */
  displayName: z.string(),
  /** `false` = pokazujemy nazwę produktu, bo klient nie ustawił własnej */
  customName: z.boolean(),
  hasLogo: z.boolean(),
  /**
   * Znacznik wersji do adresu obrazu. Bez niego przeglądarka trzymałaby STARE logo po
   * podmianie (odpowiedź z logo jest buforowana na rok) i wgranie wyglądałoby na niedziałające.
   */
  logoVersion: z.number().nullable(),
});

export type Branding = z.infer<typeof BrandingSchema>;

/** Publiczny — woła go także ekran logowania, PRZED sesją. */
export const fetchBranding = () => apiGet('/branding', BrandingSchema);

export const updateBranding = (body: { displayName?: string | null; logoDataUrl?: string; removeLogo?: boolean }) =>
  apiSend('PUT', '/branding', body, BrandingSchema);

/** Adres obrazu z wersją — patrz `logoVersion`. */
export const logoUrl = (version: number | null): string => `/api/branding/logo?v=${version ?? 0}`;
